import { createAction } from 'redux-act'

export const postUpgradeToClubStart = createAction('upgradeToClub - post upgrade to club start')

export const postUpgradeToClubSuccess = createAction('upgradeToClub - POST_UPGRADE_TO_CLUB_SUCCESS')

export const postUpgradeToClubFail = createAction<any>('upgradeToClub - POST_UPGRADE_TO_CLUB_FAIL')

export const fetchProvincesStart = createAction('upgradeToClub - FETCH_PROVINCES_START')

export const fetchProvincesSuccess = createAction<any>('upgradeToClub - FETCH_PROVINCES_SUCCESS')

export const fetchProvincesFail = createAction<any>('upgradeToClub - FETCH_PROVINCES_FAIL')
